import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { GlobalVariable } from 'app/app.global';

import * as moment from 'moment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDownloadService } from './report.download.service';
import { BindComponentService } from '../utils/bind.component.service';

/**
 * @author Edivaldo Mascarenhas
 * @version $Id: reports.callhistory.service.ts 54953 2017-08-01 19:04:16Z edivaldo.m.junior $
 */
@Injectable()
export class CallHistoryReportService extends CommonService  {

  private localURL: string;
  private VOICE_REPORTS_PATH: string = '/voicereports';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService, public reportDownloadService: ReportDownloadService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.VOICE_REPORTS_PATH;
  }

  public getLineDetails(msisdn: string) {
    let url = this.localURL + '?action=getLineDetails';
    url += '&msisdn=' + msisdn;
    return this.convertResponse(this.httpGet(url));
  }

  public getCallHistory(msisdn: string, startDate: Date, endDate: Date, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=getCallHistory';
    url += '&msisdn=' + msisdn;
    url += '&startDate=' + startDate.getTime();
    url += '&endDate=' + endDate.getTime();
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public generateReport(msisdn: string, startDate: Date, endDate: Date, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=exportCallHistory';
    url += '&msisdn=' + msisdn;
    url += '&startDate=' + startDate.getTime();
    url += '&endDate=' + endDate.getTime();
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    
	this.reportDownloadService.prepare(url);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/reports.callhistory.service.ts